// extracted by mini-css-extract-plugin
export var locationCard = "_gw-0";